export * from "./useApolloClient.js";
export * from "./useLazyQuery.js";
export * from "./useMutation.js";
export * from "./useQuery.js";
export * from "./useSubscription.js";
export * from "./useReactiveVar.js";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/react/hooks/index.js
// module id = 80
// module chunks = 0